try {
            if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');
            else require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@design-system/error-message';
import { FieldHead } from '@design-system/field-head';
import { useDomDirection } from '@design-system/hooks';
import { ContentDirection } from '@design-system/types';
import classNames from 'classnames';
import { forwardRef, useState, useRef, useCallback } from 'react';
import DatePicker from 'react-datepicker';

const DateField = forwardRef(({ id, label, isHidden = false, isDisabled, description, tooltipLabel, tooltipText, tooltipContent, onChange, onBlur, errorMessage, additionalHeadContent, className, defaultValue, name, hideDays, useLastDayOfMonth, }, ref) => {
    const [startDate, setStartDate] = useState(defaultValue ? new Date(defaultValue) : null);
    const datePickerRef = useRef(null);
    const domDirection = useDomDirection();
    const toUTC = (date) => new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
    const handleOnChange = useCallback((date) => {
        if (!date)
            return;
        const newDate = hideDays
            ? toUTC(new Date(date.getFullYear(), date.getMonth(), useLastDayOfMonth ? 0 : 1))
            : toUTC(date);
        onChange === null || onChange === void 0 ? void 0 : onChange({
            target: { value: newDate, name },
        });
        setStartDate(newDate);
    }, [name, onChange, hideDays, useLastDayOfMonth]);
    const handleOnCalendarClose = useCallback(() => {
        if (onBlur) {
            onBlur({
                target: { value: startDate, name },
            });
        }
    }, [startDate, onBlur, name]);
    return (jsxs("div", Object.assign({ className: classNames('cds-date-field', className, {
            'cds-date-field--hidden': isHidden,
        }), ref: ref }, { children: [jsx(FieldHead, { id: id, label: label, description: description, tooltipLabel: tooltipLabel, tooltipText: tooltipText, tooltipContent: tooltipContent, error: Boolean(errorMessage), additionalHeadContent: additionalHeadContent }), jsx("div", Object.assign({ className: classNames('cds-date-field__container', {
                    'cds-date-field__container--hide-days': hideDays,
                }) }, { children: jsx(DatePicker, Object.assign({ className: classNames('cds-date-field__input', {
                        'cds-date-field__input--error': Boolean(errorMessage),
                        'cds-date-field__input--disabled': isDisabled,
                    }), selected: startDate, placeholderText: hideDays ? 'MM/YYYY' : 'DD/MM/YYYY', dateFormat: hideDays ? 'MM/yyyy' : 'dd/MM/yyyy', showMonthDropdown: true, useShortMonthInDropdown: true, showYearDropdown: true, yearDropdownItemNumber: 6, disabled: isDisabled, dropdownMode: "scroll", onChange: handleOnChange, onCalendarClose: handleOnCalendarClose, showMonthYearPicker: hideDays, popperPlacement: domDirection === ContentDirection.LTR
                        ? 'bottom-start'
                        : 'bottom-end', ref: datePickerRef }, { children: jsx("div", Object.assign({ className: "react-datepicker__close-button-wrapper" }, { children: jsx("button", { className: "react-datepicker__close-button", type: "button", "aria-label": "close", onClick: () => {
                                var _a;
                                if (datePickerRef.current !== null) {
                                    (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
                                }
                            } }) })) })) })), jsx(ErrorMessage, { message: errorMessage })] })));
});

export { DateField };
